import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-supplier-code-of-conduct',
  imports: [],
  templateUrl: './supplier-code-of-conduct.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './supplier-code-of-conduct.scss',
})
export class SupplierCodeOfConduct {
  private readonly seoService = inject(SeoService);
  protected readonly seoTitle = 'Mari Group – Supplier Code of Conduct';
  protected readonly seoDescription =
    'The ethical, legal, and operational standards MARI expects of every supplier, covering business integrity, human rights, data protection, environmental responsibility, and supply chain governance.';

  constructor() {
    this.seoService.update({
      title: this.seoTitle,
      description: this.seoDescription,
      breadcrumbItems: [
        { name: 'Home', path: '/' },
        { name: 'Supplier Code of Conduct', path: '/supplier-code-of-conduct' },
      ],
    });
  }
}
